import {withStyles} from "@material-ui/styles";
import {InputBase} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import React from "react";

export const CustomInputNumber = withStyles((theme) => ({
    input: {
        textAlign: "center",
        position: 'relative',
        border: '1px solid #bdbdbd',
        padding: '7px',
        transition: theme.transitions.create(['border', 'box-shadow']),
        '&:focus': {
            borderColor: "rgba(0, 0, 0, .87)",
            boxShadow: "0 0 0 1px rgba(0, 0, 0, .87)"
        },
    },
}))(InputBase);


export const GreenCheckbox = withStyles({
    root: {
        '&$checked': {
            color: "#00b74a",
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);